import React from 'react';
import { Question } from '@phosphor-icons/react';

import { Shot } from '../../types';
import { getPluralPhrase } from '../../utils';

import { Popover } from '../general';

interface Props {
  requiredShots: Shot[];
  className?: string;
}

const ClipReselectInfo: React.FC<Props> = (props) => {
  const { requiredShots, className } = props;

  return (
    <div className={className ?? ''}>
      Our AI already selected recommended clips for{' '}
      {getPluralPhrase(requiredShots, 'wildcard spot')}, but you can re-select
      these clips{' '}
      <Popover
        header="To re-select a clip:"
        body={
          <div className="flex flex-col gap-1">
            <div>1. In the list of the clips, click on any of the clips</div>
            <div>
              2. Then, in the highlight reel preview click on the wildcard you
              want that clip to be used for
            </div>
            <div>
              If the wildcard is longer than the clip, you won't be able to
              select it.
            </div>
            <div>
              <i>Note: refreshing the page will reset your selections.</i>
            </div>
          </div>
        }
        isWide
        className="not-italic"
      >
        <span className="cursor-pointer">
          <Question
            weight="fill"
            className="text-[1.1rem] hover:fill-[url('#icon-primary-gradient')]"
          />
        </span>
      </Popover>
    </div>
  );
};

export default ClipReselectInfo;
